export class NecSlideImage {
  src: string;
  link: string;
  showDownloadBrowserBtn?: boolean;


  constructor(src: string, link: string) {
    this.src = src;
    this.link = link;
  }
}
